import axios from 'axios';

const LogUserAddressSearch = async (searchData) => {
    try {

        // Initial check because we don't want this running when on localhost, so first get the domain
        const domain = window.location.hostname;
        if (domain.includes('localhost')) {
            console.log('Skipping logging address search because on localhost');
            return;
        }

        // Step 1: Get user's IP address
        let ip = null;
        try {
            const ipResponse = await axios.get('https://api.ipify.org?format=json');
            ip = ipResponse.data.ip;
        } catch (ipError) {
            console.log('Failed to fetch IP address:', ipError);
            // Continue without IP rather than failing completely
        }

        // Step 2: Merge IP into the search data
        const dataToLog = {
            ip: ip,
            ...searchData
        };

        console.log('dataToLog', dataToLog);

        // Step 3: Send to SQS endpoint
        const response = await axios.post(
            'https://9vcop53tl6.execute-api.us-east-2.amazonaws.com/Production/log-get-quoll-address-searches',
            dataToLog,
            {
                validateStatus: false // Handle non-200 responses gracefully
            }
        );

        if (response.status !== 200) {
            console.log('Address search logging failed:', response.status);
        }
    } catch (error) {
        console.log('Error while logging address search:', error);
    }
};

export default LogUserAddressSearch;
